import { render, staticRenderFns } from "./TrainAttribute.vue?vue&type=template&id=7bd90b49"
import script from "./TrainAttribute.vue?vue&type=script&lang=js"
export * from "./TrainAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports